import {validate as uuidValidate} from 'uuid';
import groupBy from 'lodash/groupBy'
import moment from 'moment'
import {set} from 'lodash'
import questionTypes from "@/util/consts/questionTypes";
import cloneDeep from "lodash/cloneDeep";
import {RuleBuilderEvaluator} from "@farbcodegmbh/amosweb-rulebuilder";
import PriceRuleBuilderEvaluator from '@/components/farbcode-core/PriceRuleBuilderEvaluator'

export default {
    getRegistrationSteps: (state, getters) => {
        let regStartHidden = !(getters.isGroupRegistrar ||
            getters.isGroupParticipant ||
            getters.isCaregiver
        )
        let regStartDisabled = false
        let regStartInvalid = !state.stepsValidationState.regStart && !regStartHidden

        let participantsHidden = (state.eventData && !!state.eventData.noParticipants) ||
            state.groupRegistrationCreationMode
        let participantsDisabled = false || regStartInvalid
        let participantsInvalid = !state.stepsValidationState.participants && !participantsHidden

        let registrationDetailsHidden = getters.isGroupParticipant ||
            (state.eventData && (!state.eventData.questionsRegistrar || !state.eventData.questionsRegistrar.length)) ||
            state.groupRegistrationCreationMode || getters.noRegistrationQuestionsVisible
        let registrationDetailsDisabled = false || participantsInvalid || regStartInvalid
        let registrationDetailsInvalid = !state.stepsValidationState.registrationDetails && !registrationDetailsHidden

        let participantsDetailsHidden = (state.eventData && !!state.eventData.noParticipants) ||
            (state.eventData && (!state.eventData.questionsParticipants || !state.eventData.questionsParticipants.length)) ||
            (state.registrationData && (!state.registrationData.participatingPersons || !state.registrationData.participatingPersons.length)) ||
            state.groupRegistrationCreationMode || getters.noParticipantQuestionsVisible
        let participantsDetailsDisabled = false || registrationDetailsInvalid || participantsInvalid || regStartInvalid
        let participantsDetailsInvalid = !state.stepsValidationState.participantsDetails && !participantsDetailsHidden

        let paymentHidden = getters.isGroupParticipant ||
            state.groupRegistrationCreationMode || (state.eventData && !state.eventData.chargeable && state.eventData.noInvoiceRecipient)
        let paymentDisabled = false || participantsDetailsInvalid || registrationDetailsInvalid || participantsInvalid || regStartInvalid
        let paymentInvalid = !state.stepsValidationState.payment && !paymentHidden

        let regSummaryHidden = false ||
            state.groupRegistrationCreationMode
        let regSummaryDisabled = false || paymentInvalid || participantsDetailsInvalid || registrationDetailsInvalid || participantsInvalid || regStartInvalid
        let regSummaryInvalid = !state.stepsValidationState.regSummary && !regSummaryHidden


        return [
            {name: "regStart", disabled: regStartDisabled, hidden: regStartHidden},
            {name: "participants", disabled: participantsDisabled, hidden: participantsHidden},
            {name: "registrationDetails", disabled: registrationDetailsDisabled, hidden: registrationDetailsHidden},
            {name: "participantsDetails", disabled: participantsDetailsDisabled, hidden: participantsDetailsHidden},
            {name: "payment", disabled: paymentDisabled, hidden: paymentHidden},
            {name: "regSummary", disabled: regSummaryDisabled, hidden: regSummaryHidden}
        ]
    },


    // TODO maybe optimize these getters for a big number of questions/persons
    noRegistrationQuestionsVisible: (state, getters) => {
        return !state.eventData?.questionsRegistrar?.some(question => {
            if (!question.visibilityConditions) return true
            let evaluator = new RuleBuilderEvaluator(
                {
                    ...getters.getRegistrarQuestionsForRuleBuilderEvaluator,
                    registrarRegistrationDate: moment(),
                    registrationType: getters.getRegistrationType
                },
                false
            )
            return evaluator.evaluateRule(question.visibilityConditions)
        })
    },

    noParticipantQuestionsVisible: (state, getters) => {
        return !state.eventData?.questionsParticipants?.some(question => {
            if (!question.visibilityConditions) return true
            return state.registrationData.participatingPersons.some(personKey => {
                let evaluator = new RuleBuilderEvaluator(
                    {
                        ...getters.getRegistrarQuestionsForRuleBuilderEvaluator,
                        ...getters.getQuestionsForRuleBuilderEvaluator(personKey),
                        ...getters.getPersonDataForRuleBuilderEvaluator(personKey)
                    },
                    false
                )
                return evaluator.evaluateRule(question.visibilityConditions)
            })
        })
    },

    isGroupRegistrar: (state) => {
        return !!state.groupRegistrarToken || state.groupRegistrationCreationMode
    },

    isGroupParticipant: (state) => {
        return !state.groupRegistrarToken && !!state.groupParticipantToken
    },

    isCaregiver: (state) => {
        return !!(state.caregiverToken || state.caregiverCheckToken)
    },

    getNumberOfNewlyCreatedParticipants: (state) => {
        return state.registrationData.participatingPersons.filter(participatingPerson => uuidValidate(participatingPerson)).length
    },

    getNumberOfTakenFemalePlaces: (state) => {
        return getNumberOfTakenPlacesByGender('w', state)
    },

    getNumberOfTakenMalePlaces: (state) => {
        return getNumberOfTakenPlacesByGender('m', state)
    },

    getNumberOfTakenPlacesTotal: (state) => {
        if (
            state.registrationData &&
            state.registrationData.participatingPersons
        ) {
            return state.registrationData.participatingPersons.length
        }
    },

    getNumberOfRemainingFemaleParticipantPlacesWithCurrentRegistrations: (state, getters) => {
        if (state.noCheckToken ||
            getters.isCaregiver ||
            (state.eventData && state.remainingPlaces.remainingFemaleParticipantPlaces === null) ||
            (state.eventData && state.eventData.registrationWhenFullyBooked && !state.eventData.noFemaleParticipants)) {
            return null
        }

        if (state.eventData && state.remainingPlaces) {
            if (!isNaN(state.remainingPlaces.remainingFemaleParticipantPlaces)) {

                let remainingFemaleParticipantPlaces = state.remainingPlaces.remainingFemaleParticipantPlaces

                if (state.reservedPlaces?.reservedFemalePlaces) {
                    remainingFemaleParticipantPlaces -= state.reservedPlaces.reservedFemalePlaces
                }

                if (remainingFemaleParticipantPlaces < 0) {
                    remainingFemaleParticipantPlaces = 0
                }

                return remainingFemaleParticipantPlaces
                    - getters.getNumberOfTakenFemalePlaces
                    //Bei einer Gruppenanmeldung müssen wir aufpassen dass die bereits vorhanden Teilnehmer
                    //bereits von remaining...Places abgezogen worden sind. Deswegen addieren wir zu den freien Plätzen,
                    //die inital belegten Plätze. Dadurch hat ein Gruppenanmelder immer mindestens genauso viele Plätze zur Verfügung,
                    //welche bereits durch ihn belegt sind.
                    //Deswegen setzen wir oben remaining...ParticipantPlaces auch nie unter 0
                    + state.initialFemalePlacesTaken
            }
        }
        return null
    },

    getNumberOfRemainingMaleParticipantPlacesWithCurrentRegistrations: (state, getters) => {
        if (state.noCheckToken ||
            getters.isCaregiver ||
            (state.eventData && state.remainingPlaces.remainingMaleParticipantPlaces === null) ||
            (state.eventData && state.eventData.registrationWhenFullyBooked && !state.eventData.noMaleParticipants)) {
            return null
        }

        if (state.eventData && state.remainingPlaces) {
            if (!isNaN(state.remainingPlaces.remainingMaleParticipantPlaces)) {

                let remainingMaleParticipantPlaces = state.remainingPlaces.remainingMaleParticipantPlaces

                if (state.reservedPlaces?.reservedMalePlaces) {
                    remainingMaleParticipantPlaces -= state.reservedPlaces.reservedMalePlaces
                }

                if (remainingMaleParticipantPlaces < 0) {
                    remainingMaleParticipantPlaces = 0
                }

                return remainingMaleParticipantPlaces
                    - getters.getNumberOfTakenMalePlaces
                    //Bei einer Gruppenanmeldung müssen wir aufpassen dass die bereits vorhanden Teilnehmer
                    //bereits von remaining...Places abgezogen worden sind. Deswegen addieren wir zu den freien Plätzen,
                    //die inital belegten Plätze. Dadurch hat ein Gruppenanmelder immer mindestens genauso viele Plätze zur Verfügung,
                    //welche bereits durch ihn belegt sind.
                    //Deswegen setzen wir oben remaining...ParticipantPlaces auch nie unter 0
                    + state.initialMalePlacesTaken
            }
        }
        return null;
    },

    getNumberOfRemainingPlacesWithCurrentRegistrations: (state, getters) => {
        if (state.noCheckToken ||
            //Registration allowed when fully booked
            (state.eventData && state.eventData.registrationWhenFullyBooked)) {
            return null
        }

        if (state.eventData && state.remainingPlaces) {
            let remainingPlaces = null
            let reservedPlaces = null
            //Wenn Betreuer dann nutze nur die Totalen Plätze
            if (getters.isCaregiver) {
                remainingPlaces = state.remainingPlaces.remainingPlacesTotal
                reservedPlaces = state.reservedPlaces?.reservedTotalPlaces ?? 0
            }
            //Wenn Teilnehmer, nutze kleineren von beiden Werten
            else {
                remainingPlaces = state.remainingPlaces.remainingParticipantPlaces
                reservedPlaces = state.reservedPlaces?.reservedParticipantPlaces ?? 0

                if (remainingPlaces === null ||
                    (state.remainingPlaces.remainingPlacesTotal !== null &&
                        remainingPlaces > state.remainingPlaces.remainingPlacesTotal)
                ) {
                    remainingPlaces = state.remainingPlaces.remainingPlacesTotal
                    reservedPlaces = state.reservedPlaces?.reservedTotalPlaces ?? 0
                }
            }

            if (remainingPlaces === null) {
                return null
            }

            if (reservedPlaces) {
                remainingPlaces -= reservedPlaces
            }

            if (remainingPlaces < 0) {
                remainingPlaces = 0
            }

            return remainingPlaces
                - getters.getNumberOfTakenPlacesTotal
                //Bei einer Gruppenanmeldung müssen wir aufpassen dass die bereits vorhanden Teilnehmer
                //bereits von remaining...Places abgezogen worden sind. Deswegen addieren wir zu den freien Plätzen,
                //die inital belegten Plätze. Dadurch hat ein Gruppenanmelder immer mindestens genauso viele Plätze zur Verfügung,
                //welche bereits durch ihn belegt sind.
                //Deswegen setzen wir oben remainingPlaces auch nie unter 0
                + state.initialTotalPlacesTaken
        }

        return null
    },

    isAnyFieldOfInvoiceRecipientFillable: (state) => {
        if (!state.onlineRegistrationFields || !state.onlineRegistrationFields.length
            || !state.eventData) {
            return false
        }

        return !!state.onlineRegistrationFields.find((field) => {
            return !!(field.Typ === "invoiceRecipient" &&
                state.eventData.onlineRegistrationFields[field.key] > 0)
        })
    },

    isAnyFieldOfInvoiceRecipientRequired: (state) => {
        if (!state.onlineRegistrationFields || !state.onlineRegistrationFields.length
            || !state.eventData) {
            return false
        }

        return !!state.onlineRegistrationFields.find((field) => {
            return !!(field.Typ === "invoiceRecipient" &&
                state.eventData.onlineRegistrationFields[field.key] === 2)
        })
    },


    getRegistrarQuestionsForRuleBuilderEvaluator: (state, getter) => {
        return getter.getQuestionsForRuleBuilderEvaluator("registrar")
    },

    getQuestionsForRuleBuilderEvaluator: (state, getter) => (personKey) => {
        try {
            let handledAnswers = {...(state.registrationData.answers[personKey] ?? {})}

            getter.getSelectQuestionsWithOtherOption(personKey === "registrar")?.forEach(question => {
                if (handledAnswers[question.uuid]?.length) {
                    handledAnswers[question.uuid] = handledAnswers[question.uuid].map(
                        answer => uuidValidate(answer) ? answer : "others"
                    )
                }
            })

            return handledAnswers
        } catch (e) {
            return {}
        }
    },

    getSelectQuestionsWithOtherOption: (state) => (registrar = false) => {
        let relevantQuestions = registrar ? state.eventData?.questionsRegistrar : state.eventData?.questionsParticipants
        return relevantQuestions?.filter(question => {
            return question.questionType === 1 && !!question.freeTextAllowed && question.options?.length
        })
    },

    getInvoiceRecipientDataForRuleBuilderEvaluator: (state, getter) => {
        try {
            return getter.getPersonDataForRuleBuilderEvaluator(state.registrationData.invoiceReceivingPerson, true)
        } catch (e) {
            return {}
        }
    },

    getQuestionAnswerSelectionInRegistration: (state, getters) => (questionKey, optionKey = null) => {
        if (!getters.getAnswerSelectionsInRegistration) return null
        const answerSelectionInRegistration = getters.getAnswerSelectionsInRegistration[questionKey] ?? null
        const initialAnswerSelection = state.initialAnswerSelection[questionKey] ?? null

        if (!optionKey) {
            return parseInt(answerSelectionInRegistration ?? "0") - parseInt(initialAnswerSelection ?? "0")
        } else {
            return (answerSelectionInRegistration ? answerSelectionInRegistration[optionKey] : 0)
                - (initialAnswerSelection ? initialAnswerSelection[optionKey] : 0)
        }
    },

    getAvailability: (state) => (questionOrOption) => {
        return state.availabilities[questionOrOption?.uuid] ?? null
    },

    getAnswerSelectionsInRegistration: (state, getters) => {
        const answers = state.registrationData?.answers
        const participatingPersons = state.registrationData?.participatingPersons

        let questionsParticipants = cloneDeep(state.eventData?.questionsParticipants)
        questionsParticipants = questionsParticipants?.filter(participantQuestion =>
            questionHasAvailabilitySettings(participantQuestion, getters)
        )

        let questionsRegistrar = cloneDeep(state.eventData?.questionsRegistrar)
        questionsRegistrar = questionsRegistrar?.filter(registrarQuestion =>
            questionHasAvailabilitySettings(registrarQuestion, getters)
        )

        const answersTimesMap = {}

        if (!answers) return answersTimesMap


        questionsParticipants?.forEach(participantQuestion => {
            let questionAnswers = participatingPersons.map(
                personKey => answers[personKey] ? answers[personKey][participantQuestion.uuid] : []
            ).filter(questionAnswers => questionAnswers?.length)
            if (participantQuestion.questionType === questionTypes.TYPE_QUANTITY && questionAnswers?.length) {
                let questionAnswerSum = questionAnswers.reduce(
                    (sumOfQuantities, personQuestionAnswer) => (sumOfQuantities + parseInt(personQuestionAnswer[0] ?? 0)),
                    0)
                answersTimesMap[participantQuestion.uuid] = questionAnswerSum
            } else if (participantQuestion.questionType === questionTypes.TYPE_QUESTION && questionAnswers?.length) {
                answersTimesMap[participantQuestion.uuid] = {}

                participantQuestion.options?.forEach(questionOption => {
                    if (getters.getAvailability(questionOption) !== null) {
                        answersTimesMap[participantQuestion.uuid][questionOption.uuid] = questionAnswers.filter(
                            questionAnswers => questionAnswers.includes(questionOption.uuid)
                        ).length ?? 0
                    }
                })
            }
        })

        // TODO why are answers keyed with 'registrar' instead of invoiceReceivingPerson
        questionsRegistrar?.forEach(registrarQuestion => {
            let questionAnswer = answers['registrar'] ? answers['registrar'][registrarQuestion.uuid] : []

            if (!questionAnswer?.length) return

            if (registrarQuestion.questionType === questionTypes.TYPE_QUANTITY && questionAnswer?.length) {
                answersTimesMap[registrarQuestion.uuid] = parseInt(questionAnswer[0] ?? 0)
            } else if (registrarQuestion.questionType === questionTypes.TYPE_QUESTION && questionAnswer?.length) {
                answersTimesMap[registrarQuestion.uuid] = {}

                registrarQuestion.options?.forEach(questionOption => {
                    if (getters.getAvailability(questionOption) !== null) {
                        answersTimesMap[registrarQuestion.uuid][questionOption.uuid] = questionAnswer.includes(questionOption.uuid) ? 1 : 0
                    }
                })
            }
        })

        return answersTimesMap
    },

    getPersonDataForRuleBuilderEvaluator: (state) => (personKey, isInvoiceRecipient = false) => {
        try {
            const prefix = isInvoiceRecipient ? 'invoiceRecipient' : 'participant'
            const person = state.registrationData.persons[personKey]
            let personData = {}
            personData[prefix + "ContactType"] = person.type
            personData[prefix + "Salutation"] = person.salutation
            personData[prefix + "Firstname"] = person.firstname
            personData[prefix + "Lastname"] = person.lastname
            personData[prefix + "Birthday"] = person.birthday
            personData[prefix + "Plz"] = person.zipValue
            personData[prefix + "CityName"] = person.cityValue
            personData[prefix + "CommunityIdentificationNumber"] = person.communityIdentificationNumber
            personData[prefix + "HasVatId"] = person.vatId ? 1 : 0
            personData[prefix + "VatId"] = person.vatId
            if (!isInvoiceRecipient) {
                // Attention: Registration Date needs to be 'date' and not 'datetime', so that price rules are calculated correctly
                personData[prefix + "RegistrationDate"] = person.registrationDate ?? moment().startOf('day')
                let ageAtParticipation = person.ageAtParticipation ?? null
                if (!ageAtParticipation && state.eventData?.startDate && person.birthday)
                    ageAtParticipation = moment(state.eventData.startDate).diff(person.birthday, 'years')
                personData[prefix + "AgeAtParticipation"] = ageAtParticipation ?? null;
                personData["caregiver"] = person.caregiverUuid
                personData["participantGroups"] = person.participantGroupUuids
                personData["participantType"] = person.caregiverUuid ? 'caregiver' : 'participant'
            } else {
                personData["registrationType"] = (state.caregiverToken || state.caregiverCheckToken) ? 1 : 0
                personData["paymentMethod"] = state.registrationData.paymentType
            }
            return personData
        } catch (e) {
            return {}
        }
    },

    getRegistrationType: (state, getters) => {
        if (getters.isCaregiver) return 1
        return 0
        // TODO maybe check person data for group registrations
    },

    getAllInvoiceArticlesGroupedByArticle: (state, getters) => {
        return groupBy(getters.getAllInvoiceArticles, (article) => article.id)
    },

    getCouponTotal: (state, getters) => {
        let couponTotal = 0
        if (!state.registrationData) {
            return couponTotal
        }
        state.registrationData.redeemedCoupons.forEach(coupon => couponTotal += coupon.redeemedAmount)
        state.registrationData.couponsToRedeem.forEach(coupon => couponTotal += coupon.amount)

        if (getters.getInvoiceTotal > 0)
            return Math.min(couponTotal, getters.getInvoiceTotal)
        else
            return 0
    },

    getInvoiceTotal: (state, getters) => {
        let total = 0
        getters.getAllInvoiceArticles.forEach((invoiceArticle) => {
            if (invoiceArticle.isGross ?? false)
                total += roundCommercially((invoiceArticle.unitPrice ?? 0) * (invoiceArticle.amount ?? 1))
            else
                total += roundCommercially((invoiceArticle.unitPrice ?? 0) * (invoiceArticle.amount ?? 1) * (invoiceArticle.tax / 100 + 1))
        })
        return total
    },


    getAllInvoiceArticles: (state, getters) => {
        return getters.getInvoiceArticlesForRegistration.concat(getters.getInvoiceArticlesForParticipants)
    },

    getInvoiceArticlesForRegistration: (state, getters) => {
        let invoiceArticles = []

        if (
            !state.eventData ||
            !state.eventData.registerPriceRules) {
            return invoiceArticles
        }

        //Registration Articles
        if (state.eventData.registerPriceRules) {
            let priceRuleEvaluator = new PriceRuleBuilderEvaluator(
                {
                    ...getters.getInvoiceRecipientDataForRuleBuilderEvaluator,
                    ...getters.getRegistrarQuestionsForRuleBuilderEvaluator,
                    ...getters.getRegistrarRegistrationDateForRuleBuilder
                }
            )
            for (let priceRule of state.eventData.registerPriceRules) {
                invoiceArticles = invoiceArticles.concat(priceRuleEvaluator.evaluatePriceRule(priceRule))
            }
        }

        return invoiceArticles
    },

    getInvoiceArticlesForParticipants: (state, getters) => {
        let invoiceArticles = []

        if (
            !state.registrationData ||
            !state.registrationData.participatingPersons) {
            return invoiceArticles
        }

        for (let personKey of state.registrationData.participatingPersons) {
            let invoiceArticlesOfPerson = getters.getInvoiceArticlesForParticipant(personKey)

            invoiceArticlesOfPerson.forEach((invoiceArticleOfPerson) => {
                set(invoiceArticleOfPerson, 'belongsToPersonKey', personKey)
            })

            invoiceArticles = invoiceArticles.concat(invoiceArticlesOfPerson)
        }

        return invoiceArticles
    },

    getInvoiceArticlesForParticipant: (state, getters) => (personKey) => {
        let invoiceArticles = []

        if (
            !state.eventData ||
            !state.eventData.participationPriceRules ||
            !state.registrationData ||
            !state.registrationData.participatingPersons) {
            return invoiceArticles
        }

        //Participant Articles
        let priceRuleEvaluator = new PriceRuleBuilderEvaluator(
            {
                ...getters.getInvoiceRecipientDataForRuleBuilderEvaluator,
                ...getters.getRegistrarQuestionsForRuleBuilderEvaluator,
                ...getters.getPersonDataForRuleBuilderEvaluator(personKey, false),
                ...getters.getQuestionsForRuleBuilderEvaluator(personKey)
            }
        )

        for (let priceRule of state.eventData.participationPriceRules) {
            invoiceArticles = invoiceArticles.concat(priceRuleEvaluator.evaluatePriceRule(priceRule))
        }


        return invoiceArticles
    },

    chargeable: (state) => {
        if (!state.eventData) {
            return false
        }
        return state.eventData.chargeable
    }
}

function roundCommercially(number) {
    if (!number || (typeof number !== "string" && typeof number !== "number")) return number
    if (typeof number === "string") number = parseFloat(number)
    if (!number) return 0
    return Math.round((number + Number.EPSILON) * 100) / 100
}

function questionHasAvailabilitySettings(generalQuestion, getters) {
    return !!generalQuestion && ((generalQuestion.questionType === questionTypes.TYPE_QUESTION
            && generalQuestion.options?.length
            && generalQuestion.options.some(option => getters.getAvailability(option) !== null))
        || (generalQuestion.questionType === questionTypes.TYPE_QUANTITY
            && getters.getAvailability(generalQuestion) !== null))
}

function getNumberOfTakenPlacesByGender(gender, state) {
    if (state.registrationData?.participatingPersons && state.registrationData?.persons) {
        let counter = 0
        for (let participatingPerson of state.registrationData.participatingPersons) {

            if (state.registrationData.persons[participatingPerson] !== null &&
                state.registrationData.persons[participatingPerson] !== undefined &&
                state.registrationData.persons[participatingPerson].gender !== undefined
            ) {
                let personGender = state.registrationData.persons[participatingPerson].gender
                if (personGender && personGender === gender) counter++
            }

        }
        return counter
    } else {
        return 0
    }
}
